import { AxiosInstance } from "axios";
import { createLogger } from "logging";
import { EntityActionResult } from "models/EntityActionResult";

const logger = createLogger("BoardRoleApi");

export class BoardRoleApi {
  constructor(private axios: AxiosInstance) {}

  async addBoardRole(boardId: string, roleName: string, userId: string): Promise<EntityActionResult> {
    try {
      const response = await this.axios.put<EntityActionResult>(`/board-roles/${boardId}/${roleName}/${userId}`);
      return response.data;
    } catch (error) {
      logger.error("Failed to add board role", error);
      throw error;
    }
  }

  async deleteBoardRole(boardId: string, roleName: string, userId: string): Promise<EntityActionResult> {
    try {
      const response = await this.axios.delete<EntityActionResult>(`/board-roles/${boardId}/${roleName}/${userId}`);
      return response.data;
    } catch (error) {
      logger.error("Failed to remove board role", error);
      throw error;
    }
  }
}
